import { render } from "./InputTypeComponent.vue?vue&type=template&id=a4bd831c&scoped=true"
import script from "./InputTypeComponent.vue?vue&type=script&lang=js"
export * from "./InputTypeComponent.vue?vue&type=script&lang=js"

import "./InputTypeComponent.vue?vue&type=style&index=0&id=a4bd831c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bd831c"]])

export default __exports__